import { Box } from '@mui/material'
import debounce from 'lodash.debounce'
import { MuiColorInput } from 'mui-color-input'
import PropTypes from 'prop-types'
import React, { useEffect, useMemo, useState } from 'react'

const DebouncedColorPicker = ({ label, field, form, defaultColor = '', ...props }) => {
  const [localValue, setLocalValue] = useState(field.value || defaultColor)

  const debouncedOnChange = useMemo(() => debounce((val) => form.setFieldValue(field.name, val), 200), [field.name, form])

  useEffect(() => {
    setLocalValue(field.value || defaultColor)
  }, [field.value, defaultColor])

  const handleChange = (color) => {
    setLocalValue(color)
    debouncedOnChange(color)
  }

  return (
    <Box mt={2}>
      {/* FIXME: Pass in margin. */}
      <MuiColorInput format="hex" margin="none" label={label} value={localValue} onChange={handleChange} {...props} />
    </Box>
  )
}

DebouncedColorPicker.propTypes = {
  label: PropTypes.string,
  defaultColor: PropTypes.string,
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
  }),
  form: PropTypes.shape({
    setFieldValue: PropTypes.func,
  }),
}

export default DebouncedColorPicker
